module.exports = __webpack_public_path__ + "static/media/anniu5.39f39f35.png";